import { DataFilterType, DataPropType } from "./DataFilter";

export const MonthNames = Object.freeze(["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"]);
export const MonthNamesShort = Object.freeze(["Яну", "Фев", "Мар", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ное", "Дек"]);

export class DataHeader {
  /**
   *Creates an instance of Filter.
   * @param {string} text
   * @param {string} value
   * @param {DataPropType} proptype
   * @param {Object} options
   * @param {?string} options.cell_align
   * @param {?boolean} options.isHidden
   * @param {?boolean} options.summable
   * @param {?boolean} options.hideDivider
   * @param {?boolean} options.isNotForEditing
   * @param {?boolean} options.isNotInSelector
   * @param {?boolean} options.isNotForClicking
   * @param {?boolean} options.isNullable
   * @param {?boolean} options.isFileOrFolder
   * @param {?boolean} options.isLink
   * @param {?boolean} options.canBeGrouped
   * @param {?Number} options.width
   * @param {?Number} options.maxwidth
   * @param {?Number} options.editorColspan
   * @param {?DataFilterType} options.filtertype
   * @property {Array} filter
   * @property {DataFilterType} filtertype
   */
  constructor(text, value, proptype, options) {
    //cell_align, isHidden, summable, hideDivider, isNotInSelector, isNotForClicking, width) {
    this.text = text;
    this.value = value;

    this.title = text;
    this.key = value;

    if (proptype) this.proptype = proptype;
    else this.proptype = DataPropType.None;
    if (!options) options = {};

    if (value == "edit" || value == "delete") {
      this.width = 40;
    } else if (options.width) {
      this.width = options.width;
    } else {
      this.width = 200;
      // this.width = "auto";
    }

    this.groupable = true;
    this.sortable = false; // fix groupBy bug in v-data-table with disable-sort
    this.align = "center";
    this.nowrap = true;
    this.lastFixed = true;
    this.canBeClicked = true;
    this.summable = options.summable;
    this.canBeGrouped = options.canBeGrouped;
    if (options.maxwidth) this.maxwidth = options.maxwidth;
    if (options.isNullable) this.isNullable = !!options.isNullable;
    if (options.isLink) this.isLink = options.isLink;
    if (options.isFileOrFolder) this.isFileOrFolder = options.isFileOrFolder;

    if (options.editorColspan) this.editorColspan = options.editorColspan;
    else this.editorColspan = 12;

    if (options.cell_align) this.cell_align = options.cell_align;
    else this.cell_align = "start";

    if (options.isHidden !== null && options.isHidden !== undefined) {
      this.hidden = options.isHidden;
    } else {
      this.hidden = false;
    }
    if (options.isNotInSelector == null && options.isNotInSelector === undefined) {
      this.isInSelector = true;
    } else {
      this.isInSelector = !options.isNotInSelector;
    }
    this.isForEditing = true;
    if (options.isNotForEditing == true) {
      this.isForEditing = false;
    }
    if (options.isNotForClicking != null && options.isNotForClicking != undefined) {
      this.canBeClicked = false;
    }
    this.divider = !options.hideDivider;

    this.filtervalues = [];
    if (options.filtertype) {
      this.filtertype = options.filtertype;
    } else {
      switch (proptype) {
        case DataPropType.Date:
        case DataPropType.DateShort:
          this.sort = function (a, b) {
            if (!a) return 1;
            if (!b) return -1;
            return new Date(a).getTime() - new Date(b).getTime();
          };

          this.filtertype = DataFilterType.Between;
          this.filtervalues = [];
          break;

        case DataPropType.Month:
          this.sort = function (a, b) {
            return MonthNames.indexOf(a) - MonthNames.indexOf(b);
          };
          this.filtertype = DataFilterType.In;
          this.filtervalues = [];
          break;

        case DataPropType.MonthShort:
          this.sort = function (a, b) {
            return MonthNamesShort.indexOf(a) - MonthNamesShort.indexOf(b);
          };
          this.filtertype = DataFilterType.In;
          this.filtervalues = [];
          break;

        case DataPropType.BOOL:
          this.sort = function (a, b) {
            return Number(a) - Number(b);
          };
          this.filtertype = DataFilterType.Equals;
          this.filtervalues = [null];
          break;

        case DataPropType.Identificator:
        case DataPropType.Number:
        case DataPropType.QTY:
        case DataPropType.Money: //??
        case DataPropType.Money4digits: //??
          this.sort = function (a, b) {
            return a - b;
          };
          this.filtertype = DataFilterType.Between;
          this.filtervalues = [null, null];
          break;

        case DataPropType.WeekDays:
          this.sort = function (a, b) {
            if (a < b || a === undefined) {
              return -1;
            }
            if (a > b || b === undefined) {
              return 1;
            }
            return 0;
          };
          this.filtertype = DataFilterType.In;
          this.filtervalues = [];
          break;

        case DataPropType.Object:
          this.sort = function (a, b) {
            if (a.toString() < b.toString() || a === undefined) {
              return -1;
            }
            if (a.toString() > b.toString() || b === undefined) {
              return 1;
            }
            return 0;
          };
          this.filtertype = DataFilterType.In;
          this.filtervalues = [];
          break;

        case DataPropType.String:
        case DataPropType.HTMLString:
        default:
          this.sort = function (a, b) {
            if (a < b || a === undefined) {
              return -1;
            }
            if (a > b || b === undefined) {
              return 1;
            }
            return 0;
          };
          if (this.value.indexOf(".") == -1) {
            this.filtertype = DataFilterType.Contains;
            this.filtervalues = [""];
          } else {
            this.filtertype = DataFilterType.In;
            this.filtervalues = [];
          }
          break;
      }
    }
  }
}
